import { render, staticRenderFns } from "./FloorRoundDisplay.vue?vue&type=template&id=1523faf2&scoped=true"
import script from "./FloorRoundDisplay.vue?vue&type=script&lang=js"
export * from "./FloorRoundDisplay.vue?vue&type=script&lang=js"
import style0 from "./FloorRoundDisplay.vue?vue&type=style&index=0&id=1523faf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1523faf2",
  null
  
)

export default component.exports